import { PageContainer, PageHeader } from '@/components/layout/PageHeader';
import { PermissionsPanel } from '@/features/permissions/PermissionsPanel';
import { TwoFactorPolicyPanel } from '@/features/permissions/TwoFactorPolicyPanel';
import { useCurrentUser } from '@/lib/auth/session';

/** Perfis da equipe Fluxus (T-026d): o Administrador Fluxus é travado; o Consultor é editável. */
export function PerfisEquipePage() {
  const user = useCurrentUser();
  return (
    <PageContainer className="max-w-5xl">
      <PageHeader
        title="Perfis da equipe"
        description="O que os consultores da Fluxus podem fazer nas empresas em que estão alocados. O Administrador Fluxus sempre tem acesso total."
      />
      <TwoFactorPolicyPanel organizationId={user.organization.id} />
      <PermissionsPanel organizationId={user.organization.id} team />
    </PageContainer>
  );
}
